"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _ramda = require("ramda");

var _tracking_utility = require("../../../../packages/common-utilities/src/tracking_utility");

var _accessibility_utility = require("../../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var IcAutoSuggestion = function (_React$Component) {
  _inherits(IcAutoSuggestion, _React$Component);

  function IcAutoSuggestion(props) {
    _classCallCheck(this, IcAutoSuggestion);

    var _this = _possibleConstructorReturn(this, (IcAutoSuggestion.__proto__ || Object.getPrototypeOf(IcAutoSuggestion)).call(this, props));

    _this.trackSuggestionBoxClickGAEvent = function (selectedItem) {
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaEvent',
        'eventCategory': 'investment comparison modal',
        'eventAction': 'Add fund',
        'eventLabel': selectedItem.ticker + " - " + selectedItem.name
      });
    };

    _this.renderAddFundButtonOrAddedTicker = _this.renderAddFundButtonOrAddedTicker.bind(_this);
    _this.renderSuggestResultRowStyle = _this.renderSuggestResultRowStyle.bind(_this);
    _this.renderAddFund = _this.renderAddFund.bind(_this);
    _this.trackSuggestionBoxClickGAEvent = _this.trackSuggestionBoxClickGAEvent.bind(_this);
    return _this;
  }

  _createClass(IcAutoSuggestion, [{
    key: "renderAddFundButtonOrAddedTicker",
    value: function renderAddFundButtonOrAddedTicker(figiId) {
      var _this2 = this;

      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (this.props.figiIDs.length < 3) {
        if (this.props.figiIDs.includes(figiId)) {
          return _react2.default.createElement(
            "div",
            {
              className: "height-percent-100 ic-fund-search-added-fund-text display-flex align-items-center justify-content-center body2" },
            "Added"
          );
        }
        return _react2.default.createElement("button", {
          className: "height-percent-100 ic-fund-search-add-fund-btn display-flex align-items-center justify-content-center",
          "aria-label": "Add " + ticker + " fund",
          onClick: function onClick() {
            return _this2.props.addingFund(figiId);
          },
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.props.addingFund.bind(_this2, figiId));
          } });
      }
      return null;
    }
  }, {
    key: "renderSuggestResultRowStyle",
    value: function renderSuggestResultRowStyle(figiId) {
      if (this.props.figiIDs.length < 3) {
        if (this.props.figiIDs.includes(figiId)) {
          return "ic-fund-search-suggestion-item-selected";
        }
        return "ic-fund-search-suggestion-item";
      }
      return "ic-fund-search-suggestion-item-selected";
    }
  }, {
    key: "renderAddFund",
    value: function renderAddFund(figiId) {
      if (this.props.figiIDs.length < 3) {
        if (this.props.figiIDs.includes(figiId)) {
          return null;
        }
        return this.props.addingFund(figiId);
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return mapIndexed(function (searchResult, i) {
        return _react2.default.createElement(
          "div",
          { ref: function ref(div) {
              return _this3["suggestion-" + i] = div;
            }, key: i, id: "suggestionitem-" + i,
            "data-testid": "suggestionitem-" + i, onClick: function onClick() {
              return _this3.trackSuggestionBoxClickGAEvent(searchResult);
            } },
          _react2.default.createElement(
            "div",
            { className: _this3.renderSuggestResultRowStyle(searchResult.figiId) + " tag",
              onClick: function onClick() {
                return _this3.renderAddFund(searchResult.figiId);
              } },
            _react2.default.createElement(
              "div",
              { className: "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xlg-3" },
              _react2.default.createElement(
                "div",
                {
                  className: "height-percent-100 tag display-flex align-items-center justify-content-center" },
                searchResult.ticker
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xlg-7" },
              _react2.default.createElement(
                "div",
                {
                  className: "height-percent-100 Body2 text-left display-flex align-items-center" },
                searchResult.name
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xlg-1" },
              _this3.renderAddFundButtonOrAddedTicker(searchResult.figiId, searchResult.ticker)
            )
          )
        );
      }, this.props.autoCompleteData);
    }
  }]);

  return IcAutoSuggestion;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(IcAutoSuggestion, { withRef: true });